/* Meyer Woodworks: engraving options + live preview for the Knife Display Case */
(function () {
  var box = document.querySelector('[data-mw-engrave]');
  if (!box) return;

  var SCRIPT_META = window.MW_SCRIPT_META || {};
  var scriptUrlA = box.getAttribute('data-script-url') || '';
  var LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  var NS = 'http://www.w3.org/2000/svg';
  var FONT = "'MW Charter', Charter, 'Bitstream Charter', Georgia, serif";

  var styleInputs = box.querySelectorAll('input[name="mw-style"]');
  var nameI = box.querySelector('[data-mw-name]');
  var bigI = box.querySelector('[data-mw-big]');
  var letterI = box.querySelector('[data-mw-letter]');
  var detailsI = box.querySelector('[data-mw-details]');
  var approveI = box.querySelector('[data-mw-approve]');
  var preview = box.querySelector('[data-mw-preview]');
  var alphaGrid = box.querySelector('[data-mw-alpha]');
  var alphaWrap = box.querySelector('[data-mw-alpha-wrap]');
  var err = box.querySelector('[data-mw-err]');
  var bigTouched = false;

  function el(tag, attrs, parent) {
    var n = document.createElementNS(NS, tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }
  function style() {
    var c = box.querySelector('input[name="mw-style"]:checked');
    return c ? c.value : '';
  }
  function engraved() {
    if (document.querySelector('variant-selects input[type=radio]:checked[value="Engraved acrylic"]')) return true;
    var s = document.querySelectorAll('variant-selects select');
    for (var i = 0; i < s.length; i++) if (s[i].value === 'Engraved acrylic') return true;
    return false;
  }
  function scriptUrl(L) { return scriptUrlA.replace('mw-script-A.svg', 'mw-script-' + L + '.svg'); }
  function cleanLetter(v) { v = (v || '').trim().toUpperCase(); return /^[A-Z]$/.test(v) ? v : ''; }

  // ---- drawing ----
  function fitText(t, maxW, maxH) {
    var size = maxH;
    t.setAttribute('font-size', size);
    var w = t.getComputedTextLength ? t.getComputedTextLength() : 0;
    if (w > maxW && w > 0) { size = size * maxW / w; t.setAttribute('font-size', size); }
    return size;
  }

  function drawCharterSplit(svg, L, name) {
    svg.setAttribute('viewBox', '0 0 800 600');
    var defs = el('defs', {}, svg);
    var id = 'mwclip' + Math.random().toString(36).slice(2, 8);
    var cp = el('clipPath', { id: id }, defs);
    el('rect', { x: 0, y: 0, width: 800, height: 238 }, cp);
    el('rect', { x: 0, y: 362, width: 800, height: 238 }, cp);
    var g = el('g', { 'clip-path': 'url(#' + id + ')' }, svg);
    var big = el('text', { x: 400, y: 530, 'text-anchor': 'middle', 'font-family': FONT, 'font-size': 685, fill: '#141414' }, g);
    big.textContent = L;
    var bb = { x: 120, width: 560 };
    try { bb = big.getBBox(); } catch (e) {}
    var x0 = Math.max(10, bb.x - 8), x1 = Math.min(790, bb.x + bb.width + 8);
    var nm = null;
    if (name) {
      nm = el('text', { x: 400, y: 300, 'text-anchor': 'middle', 'dominant-baseline': 'central', 'font-family': FONT, fill: '#141414' }, svg);
      nm.textContent = name;
      fitText(nm, 720, 86);
      try { var nb = nm.getBBox(); x0 = Math.max(10, Math.min(x0, nb.x - 16)); x1 = Math.min(790, Math.max(x1, nb.x + nb.width + 16)); } catch (e) {}
    }
    el('rect', { x: x0, y: 240, width: x1 - x0, height: 9, fill: '#141414' }, svg);
    el('rect', { x: x0, y: 351, width: x1 - x0, height: 9, fill: '#141414' }, svg);
  }

  function drawScriptSplit(svg, L, name) {
    var m = SCRIPT_META[L];
    svg.setAttribute('viewBox', '0 0 792 612');
    if (!m) {
      var t = el('text', { x: 396, y: 290, 'text-anchor': 'middle', 'font-family': FONT, 'font-size': 34, fill: '#5a554d' }, svg);
      t.textContent = 'Script ' + L + ' preview coming soon';
      if (name) {
        var t2 = el('text', { x: 396, y: 340, 'text-anchor': 'middle', 'font-family': FONT, 'font-size': 30, fill: '#5a554d' }, svg);
        t2.textContent = 'Name: ' + name;
      }
      return false;
    }
    el('image', { href: scriptUrl(L), x: 0, y: 0, width: 792, height: 612 }, svg);
    if (name) {
      var cy = (m.gap[0] + m.gap[1]) / 2, h = m.gap[1] - m.gap[0];
      var nm = el('text', { x: (m.x0 + m.x1) / 2, y: cy, 'text-anchor': 'middle', 'dominant-baseline': 'central', 'font-family': FONT, fill: '#141414' }, svg);
      nm.textContent = name;
      fitText(nm, (m.x1 - m.x0) * 0.86, h * 0.62);
    }
    return true;
  }

  function drawSingle(svg, L) {
    svg.setAttribute('viewBox', '0 0 800 600');
    var big = el('text', { x: 400, y: 530, 'text-anchor': 'middle', 'font-family': FONT, 'font-size': 685, fill: '#141414' }, svg);
    big.textContent = L;
  }

  function newSvg(parent) {
    while (parent.firstChild) parent.removeChild(parent.firstChild);
    return el('svg', { role: 'img', 'aria-label': 'Engraving preview', preserveAspectRatio: 'xMidYMid meet' }, parent);
  }

  function render() {
    var s = style();
    box.querySelectorAll('[data-mw-show]').forEach(function (n) {
      var list = n.getAttribute('data-mw-show').split(' ');
      n.hidden = list.indexOf(s) === -1;
    });
    if (!preview) return;
    var name = (nameI.value || '').trim();
    if (!bigTouched) bigI.value = cleanLetter(name.charAt(0)) || bigI.value;
    var L = cleanLetter(bigI.value);
    var svg = newSvg(preview);
    if (s === 'split-charter' && L) drawCharterSplit(svg, L, name);
    else if (s === 'split-script' && L) drawScriptSplit(svg, L, name);
    else if (s === 'single' && cleanLetter(letterI.value)) drawSingle(svg, cleanLetter(letterI.value));
    else {
      svg.setAttribute('viewBox', '0 0 800 600');
      var t = el('text', { x: 400, y: 310, 'text-anchor': 'middle', 'font-family': FONT, 'font-size': 34, fill: '#8a8378' }, svg);
      t.textContent = s === 'single' ? 'Enter a letter to see your preview' : 'Enter a name to see your preview';
    }
    renderAlpha();
  }

  var alphaFor = '';
  function renderAlpha() {
    var s = style();
    if (!alphaWrap) return;
    var show = s === 'split-charter' || s === 'split-script' || s === 'single';
    alphaWrap.hidden = !show;
    if (!show || !alphaWrap.open || alphaFor === s) return;
    alphaFor = s;
    alphaGrid.innerHTML = '';
    LETTERS.forEach(function (L) {
      var cell = document.createElement('button');
      cell.type = 'button';
      cell.className = 'mw-alpha__cell';
      cell.setAttribute('aria-label', 'Use letter ' + L);
      alphaGrid.appendChild(cell);
      var svg = el('svg', { preserveAspectRatio: 'xMidYMid meet' }, cell);
      if (s === 'split-charter') drawCharterSplit(svg, L, '');
      else if (s === 'split-script') drawScriptSplit(svg, L, '');
      else drawSingle(svg, L);
      cell.addEventListener('click', function () {
        if (s === 'single') letterI.value = L; else { bigI.value = L; bigTouched = true; }
        render();
      });
    });
  }

  // ---- show/hide with the Front option ----
  function sync() {
    box.hidden = !engraved();
    if (box.hidden && err) err.hidden = true;
  }
  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-selects')) setTimeout(sync, 60);
  });

  styleInputs.forEach(function (i) { i.addEventListener('change', function () { if (approveI) approveI.checked = false; render(); }); });
  [nameI, letterI, detailsI].forEach(function (i) { if (i) i.addEventListener('input', function () { if (approveI) approveI.checked = false; if (err) err.hidden = true; render(); }); });
  if (bigI) bigI.addEventListener('input', function () { bigTouched = bigI.value.trim() !== ''; if (approveI) approveI.checked = false; render(); });
  if (approveI) approveI.addEventListener('change', function () { if (approveI.checked && err) err.hidden = true; });
  if (alphaWrap) alphaWrap.addEventListener('toggle', function () { alphaFor = ''; renderAlpha(); });
  if (document.fonts && document.fonts.load) document.fonts.load("100px 'MW Charter'").then(render, render);

  // ---- add to cart: validate and attach line item properties ----
  var LABELS = { 'split-charter': 'Split monogram - Charter', 'split-script': 'Split monogram - Script', 'single': 'Single letter', 'other': 'Custom engraving' };
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('product-form form[action*="/cart/add"]')) return;
    form.querySelectorAll('input[data-mw-prop]').forEach(function (n) { n.remove(); });
    function add(k, v) {
      var h = document.createElement('input');
      h.type = 'hidden'; h.name = 'properties[' + k + ']'; h.value = v; h.setAttribute('data-mw-prop', '1');
      form.appendChild(h);
    }
    if (!engraved()) { add('Engraving', 'No engraving'); return; }
    var s = style(), msg = '';
    var name = (nameI.value || '').trim(), L = cleanLetter(bigI.value), one = cleanLetter(letterI.value), det = (detailsI.value || '').trim();
    if (!s) msg = 'Please choose an engraving style.';
    else if ((s === 'split-charter' || s === 'split-script') && (!name || !L)) msg = 'Please enter the name and the big letter.';
    else if (s === 'single' && !one) msg = 'Please enter the letter to engrave.';
    else if (s === 'other' && !det) msg = 'Please describe what you would like engraved.';
    else if (s !== 'other' && approveI && !approveI.checked) msg = 'Please check the preview and tick the box to approve your engraving.';
    if (msg) {
      e.preventDefault(); e.stopImmediatePropagation();
      err.textContent = msg; err.hidden = false;
      box.scrollIntoView({ block: 'center', behavior: 'smooth' });
      return;
    }
    add('Engraving style', LABELS[s]);
    if (s === 'split-charter' || s === 'split-script') { add('Name', name); add('Big letter', L); }
    if (s === 'single') add('Letter', one);
    if (s === 'other') add('Engraving details', det);
    if (s !== 'other') add('Engraving preview approved', 'Yes');
  }, true);

  sync();
  render();
})();
